import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { selectPath } from '../../state/path/path.selectors'
import { DownloadButton } from '../common/download-button/download-button.component'
import { RouteList } from '../route-list/route-list.component'
import { SidebarStyled } from './sidebar.styled'
import { waypointsToGpx } from '../../lib/gpx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'

const SidebarComponent = (props: any) => {
  // Start file download.
  return (
    <SidebarStyled>
      <div className='header'>
        <h1>Route Builder</h1>
      </div>
      <div className='content'>
        <RouteList />
      </div>
      <div className='footer'>
        <DownloadButton
          href={`data:text/plain;charset=utf-8, ${encodeURIComponent(
            waypointsToGpx(props.path)
          )}`}
          download='Komoot_Challenge_Route.gpx'
          className='download-btn'
        >
          <span className='icon'>
            <FontAwesomeIcon icon={faDownload} />
          </span>
          <label>Download Your Route</label>
        </DownloadButton>
      </div>
      <div className='overlay'></div>
    </SidebarStyled>
  )
}

const pathProps = createStructuredSelector({
  path: selectPath,
})

export const Sidebar = connect(pathProps)(SidebarComponent)
